import type { FC } from 'react'
import React, { useMemo } from 'react'
import Moment from 'moment'
import { useTranslation } from 'react-i18next'
import { OneDatePicker } from '@yy/one-ui'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import RULES from '../../../../rules'

interface IProps {
  defaultValue?: string
  required?: boolean
}

export const InvoiceDateField: FC<IProps> = (props) => {
  const { defaultValue, required = false } = props
  const { t } = useTranslation()

  /**
   * 必须为必填且默认为空才生成
   * 生成规则跟后端一样，8位数字无需考虑重复问题
   */
  const finalDefaultValue = useMemo(() => {
    if (required && !defaultValue) {
      return Moment()
    }

    return defaultValue
  }, [defaultValue, required])

  return (
    <FormItem
      name="provider_invoice_date"
      initialValue={finalDefaultValue}
      label={`${t('provider.invoice_date')}${required ? '' : t('logistics.create.optional')}`}
      required={required}
      rules={RULES.provider_invoice_date({
        isRequired: required,
      })}
    >
      <OneDatePicker style={{ width: '100%' }} format="yyyy-MM-DD" placeholder={t('common.select.placeholder')} />
    </FormItem>
  )
}
